import axios, {
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosResponse
} from 'axios';
import { API_CONFIG, HTTP_STATUS, type BaseResponse } from './config';
import { ElMessage } from 'element-plus';
import router from '@/router';

// 创建axios实例
const httpInstance: AxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS
});

// 请求拦截器
httpInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 在发送请求之前做些什么，例如添加token
    const token = localStorage.getItem('token');
    if (token) {
      // 使用类型断言来处理headers
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['pte-token'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
httpInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data } = response;

    // 根据自定义code判断请求是否成功
    if (data.code === HTTP_STATUS.SUCCESS) {
      // 请求成功直接返回数据
      return data as any;
    } else {
      // 处理业务错误
      handleBusinessError(data);
      return Promise.reject(data);
    }
  },
  error => {
    // 处理HTTP错误
    handleHttpError(error);
    return Promise.reject(error);
  }
);

// 处理业务错误
const handleBusinessError = (data: BaseResponse) => {
  const message = data.message || '操作失败，请稍后重试';
  ElMessage.error(message);
  console.error(`业务错误: ${message}`, data);
};

// 处理HTTP错误
const handleHttpError = (error: any) => {
  let message = '请求失败';

  if (error.response) {
    const { status } = error.response;

    // 根据状态码处理不同的错误
    switch (status) {
      case HTTP_STATUS.UNAUTHORIZED:
        message = '未授权，请重新登录';
        // 清除 token 并跳转到登录页
        localStorage.removeItem('token');
        router.push('/login');
        break;
      case HTTP_STATUS.FORBIDDEN:
        message = '拒绝访问';
        break;
      case HTTP_STATUS.NOT_FOUND:
        message = '请求的资源不存在';
        break;
      case HTTP_STATUS.SERVER_ERROR:
        message = '服务器错误，请稍后重试';
        break;
      default:
        message = error.response?.data?.message || `请求错误: ${status}`;
    }
  } else if (error.request) {
    message = '网络异常，请检查您的网络连接';
  } else {
    message = `请求配置错误: ${error.message}`;
  }

  // 显示错误提示
  ElMessage.error(message);

  console.error('HTTP错误:', message, error);
};

export default httpInstance;
